import { defineStore } from "pinia";

import type {
  openSnackbarParameters,
  SnackbarState,
} from "@/types/stores/snackbarStore.type.ts";

export const useSnackbarStore = defineStore("snackbar", {
  state: (): SnackbarState => ({
    visible: false,
    text: "",
    color: "success",
  }),
  actions: {
    openSnackbar(parameters: openSnackbarParameters) {
      this.visible = true;
      this.text = parameters.text;
      this.color = parameters.color;
    },
  },
});
